import type { WithActiveBranchId } from '../shared';

export enum AiServicesEndpoints {
  Get = 'GetAiServices',
  Enable = 'EnableAiService',
}

export interface ModelAiService {
  Key: string | null;
  IsOn: boolean;
}

export type GetAiServicesRequest = WithActiveBranchId;
export type GetAiServicesResponse = ModelAiService[];

export type EnableAiServiceRequest = WithActiveBranchId<{
  Key: string;
  IsOn: boolean;
}>;
export type EnableAiServiceResponse = void;
